var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { showSurface } from "../../../redux/awaitedSurfacesSlice";
import { Search } from "@mui/icons-material";
import { Box, Chip, Typography, useMediaQuery } from "@mui/material";
import { FilterFunnel } from "../../../builderPackage/assets/svg";
import { PlusIcon } from "../assets/svg";
import FieldFailureReportCatalog from "../components/fieldFailureReportCatalog";
import { FieldFailureReportsKeys } from "../services/entity";
import { getUpdateKey } from "../../../builderPackage/common/commonFunctions";
import { setReducerState } from "../../../redux/crudSlice";
import DataRangeFiltersDrawer from "../components/DateRangeFiltersDrawer";
import { fieldFailureReportsCountAPI } from "../services/apiCalls";
import { useNavigate } from "react-router-dom";
var FieldFailureReports = function () {
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var crud = useAppSelector(function (state) { return state.crud; });
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var handlePagingUpdate = function (state) {
        console.log("state--->", state === null || state === void 0 ? void 0 : state.SelectedButton);
        var updateKey = getUpdateKey(FieldFailureReportsKeys.Paging + ((state === null || state === void 0 ? void 0 : state.SelectedButton) || 'All'));
        dispatch(setReducerState({
            key: updateKey,
            value: true
        }));
    };
    var fieldFailureReportCount = crud[FieldFailureReportsKeys.count];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: "",
            columnSize: 12,
            spacing: 0,
            columnGap: 1.5,
            alignItems: "center",
            py: 2.5,
            px: 3,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: "",
                    fontSize: "xxl",
                    fontWeight: "strong",
                    children: "Field failure reports",
                    columnSize: 0
                }, {
                    type: FormItemTypes.Chip,
                    name: "all",
                    label: fieldFailureReportCount === null || fieldFailureReportCount === void 0 ? void 0 : fieldFailureReportCount.all,
                    columnSize: 0,
                    color: "info",
                    setFormState: function () { return ({
                        SelectedButton: fieldFailureReportCount
                    }); },
                    sx: {
                        borderRadius: 1
                    }
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: "",
            columnSize: 12,
            spacing: 0,
            columnGap: 1.5,
            alignItems: "center",
            py: 1,
            px: {
                xs: 2,
                sm: 3
            },
            borderTop: "1px solid",
            borderBottom: "1px solid",
            bgcolor: "secondary.100",
            borderColor: "secondary.200",
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: "search",
                    placeholder: "Search by chassis no, model, part, repair type",
                    columnSize: true,
                    InputProps: {
                        startAdornment: /*#__PURE__*/ React.createElement(Search, {
                            color: "secondary",
                            fontSize: "small"
                        })
                    },
                    sx: {
                        maxWidth: 320
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: "filterButton",
                    startIcon: /*#__PURE__*/ React.createElement(FilterFunnel, null),
                    columnSize: 0,
                    variant: "outlined",
                    color: "secondary",
                    setFormState: function (state) { return __awaiter(void 0, void 0, void 0, function () {
                        var filters;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                        type: "Drawer",
                                        Component: DataRangeFiltersDrawer,
                                        componentProps: {
                                            request: {
                                                FromDate: state.FromDate,
                                                ToDate: state.ToDate,
                                                DataRange: state.DataRange
                                            }
                                        },
                                        containerProps: {
                                            anchor: lgMode ? "right" : 'bottom',
                                            PaperProps: {
                                                sx: {
                                                    width: {
                                                        xs: '100%',
                                                        sm: '70%',
                                                        md: '40%'
                                                    },
                                                    height: {
                                                        xs: '80%',
                                                        sm: '100%'
                                                    },
                                                    borderTopLeftRadius: 16,
                                                    borderTopRightRadius: 16
                                                }
                                            }
                                        }
                                    }))];
                                case 1:
                                    filters = _a.sent();
                                    return [2 /*return*/, _objectSpread({}, filters.payload)];
                            }
                        });
                    }); },
                    children: lgMode ? "Filters" : ''
                }, lgMode ? {
                    type: FormItemTypes.Divider,
                    name: 'Divider',
                    orientation: 'vertical',
                    columnSize: 0,
                    containerProps: {
                        height: '100%'
                    }
                } : null, lgMode ? {
                    type: FormItemTypes.Button,
                    variant: 'contained',
                    name: "new",
                    startIcon: /*#__PURE__*/ React.createElement(PlusIcon, null),
                    columnSize: 0,
                    children: 'New',
                    onClick: function () { return navigate('/fieldFailureReports/create'); }
                } : null]
        }, {
            type: FormItemTypes.ContainerItem,
            name: "SelectedButton",
            value: 'All',
            columnSize: 12,
            spacing: 0,
            columnGap: 1.5,
            alignItems: "center",
            py: 2.5,
            px: {
                xs: 2,
                sm: 3
            },
            elements: [{
                    type: FormItemTypes.CardComponent,
                    name: "",
                    columnSize: 0,
                    containerProps: {
                        maxWidth: '100%'
                    },
                    sx: {
                        bgcolor: "secondary.100",
                        p: 0.5,
                        overflow: 'auto',
                        scrollbarWidth: 'none'
                    },
                    contentProps: {
                        spacing: 0,
                        columnGap: 0.5,
                        flexWrap: 'nowrap'
                    },
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "All",
                            color: "secondary",
                            columnSize: 0,
                            setFormState: function () { return ({
                                SelectedButton: "All"
                            }); },
                            setFieldProps: function (formValues, currValue) {
                                return {
                                    type: FormItemTypes.Button,
                                    sx: {
                                        color: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? 'black' : ''
                                    },
                                    children: /*#__PURE__*/ React.createElement(Box, {
                                        display: "flex",
                                        gap: 1,
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    }, /*#__PURE__*/ React.createElement(Typography, {
                                        fontWeight: 'bold'
                                    }, " ", "All"), /*#__PURE__*/ React.createElement(Chip, {
                                        label: fieldFailureReportCount === null || fieldFailureReportCount === void 0 ? void 0 : fieldFailureReportCount.all,
                                        size: "small",
                                        variant: "filled",
                                        color: "secondary",
                                        sx: {
                                            color: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? 'black' : '',
                                            borderRadius: 6,
                                            px: 1,
                                            fontWeight: "bold",
                                            fontSize: 12
                                        }
                                    })),
                                    variant: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? "outlined" : "text"
                                };
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: "Open",
                            color: "secondary",
                            columnSize: 0,
                            setFormState: function () { return ({
                                SelectedButton: "Open"
                            }); },
                            setFieldProps: function (formValues, currValue) {
                                return {
                                    type: FormItemTypes.Button,
                                    sx: {
                                        color: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? 'black' : ''
                                    },
                                    children: /*#__PURE__*/ React.createElement(Box, {
                                        display: "flex",
                                        gap: 1,
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    }, /*#__PURE__*/ React.createElement(Typography, {
                                        fontWeight: 'bold'
                                    }, " ", "Open"), /*#__PURE__*/ React.createElement(Chip, {
                                        label: fieldFailureReportCount === null || fieldFailureReportCount === void 0 ? void 0 : fieldFailureReportCount.open,
                                        size: "small",
                                        variant: "filled",
                                        color: "secondary",
                                        sx: {
                                            color: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? 'black' : '',
                                            borderRadius: 6,
                                            px: 1,
                                            fontWeight: "bold",
                                            fontSize: 12
                                        }
                                    })),
                                    variant: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? "outlined" : "text"
                                };
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: "SubmittedByDealer",
                            color: "secondary",
                            columnSize: 0,
                            setFormState: function () { return ({
                                SelectedButton: "SubmittedByDealer"
                            }); },
                            setFieldProps: function (formValues, currValue) {
                                return {
                                    type: FormItemTypes.Button,
                                    sx: {
                                        color: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? 'black' : ''
                                    },
                                    children: /*#__PURE__*/ React.createElement(Box, {
                                        display: "flex",
                                        gap: 1,
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    }, /*#__PURE__*/ React.createElement(Typography, {
                                        fontWeight: 'bold'
                                    }, " ", "Submitted"), /*#__PURE__*/ React.createElement(Chip, {
                                        label: fieldFailureReportCount === null || fieldFailureReportCount === void 0 ? void 0 : fieldFailureReportCount.submitted,
                                        size: "small",
                                        variant: "filled",
                                        color: "secondary",
                                        sx: {
                                            color: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? 'black' : '',
                                            borderRadius: 6,
                                            px: 1,
                                            fontWeight: "bold",
                                            fontSize: 12
                                        }
                                    })),
                                    variant: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? "outlined" : "text"
                                };
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: "RevertedByASM",
                            color: "secondary",
                            columnSize: 0,
                            setFormState: function () { return ({
                                SelectedButton: "RevertedByASM"
                            }); },
                            setFieldProps: function (formValues, currValue) {
                                return {
                                    type: FormItemTypes.Button,
                                    sx: {
                                        color: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? 'black' : ''
                                    },
                                    children: /*#__PURE__*/ React.createElement(Box, {
                                        display: "flex",
                                        gap: 1,
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    }, /*#__PURE__*/ React.createElement(Typography, {
                                        fontWeight: 'bold'
                                    }, " ", "Reverted"), /*#__PURE__*/ React.createElement(Chip, {
                                        label: fieldFailureReportCount === null || fieldFailureReportCount === void 0 ? void 0 : fieldFailureReportCount.reverted,
                                        size: "small",
                                        variant: "filled",
                                        color: "secondary",
                                        sx: {
                                            color: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? 'black' : '',
                                            borderRadius: 6,
                                            px: 1,
                                            fontWeight: "bold",
                                            fontSize: 12
                                        }
                                    })),
                                    variant: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? "outlined" : "text"
                                };
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: "Closed",
                            color: "secondary",
                            columnSize: 0,
                            setFormState: function () { return ({
                                SelectedButton: "Closed"
                            }); },
                            setFieldProps: function (formValues, currValue) {
                                return {
                                    type: FormItemTypes.Button,
                                    sx: {
                                        color: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? 'black' : ''
                                    },
                                    children: /*#__PURE__*/ React.createElement(Box, {
                                        display: "flex",
                                        gap: 1,
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    }, /*#__PURE__*/ React.createElement(Typography, {
                                        fontWeight: 'bold'
                                    }, " ", "Closed"), /*#__PURE__*/ React.createElement(Chip, {
                                        label: fieldFailureReportCount === null || fieldFailureReportCount === void 0 ? void 0 : fieldFailureReportCount.closed,
                                        size: "small",
                                        variant: "filled",
                                        color: "secondary",
                                        sx: {
                                            color: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? 'black' : '',
                                            borderRadius: 6,
                                            px: 1,
                                            fontWeight: "bold",
                                            fontSize: 12
                                        }
                                    })),
                                    variant: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? "outlined" : "text"
                                };
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: "ResubmittedToASM",
                            color: "secondary",
                            columnSize: 0,
                            setFormState: function () { return ({
                                SelectedButton: "ResubmittedToASM"
                            }); },
                            setFieldProps: function (formValues, currValue) {
                                return {
                                    type: FormItemTypes.Button,
                                    sx: {
                                        color: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? 'black' : ''
                                    },
                                    children: /*#__PURE__*/ React.createElement(Box, {
                                        display: "flex",
                                        gap: 1,
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    }, /*#__PURE__*/ React.createElement(Typography, {
                                        fontWeight: 'bold'
                                    }, " ", "Resubmitted"), /*#__PURE__*/ React.createElement(Chip, {
                                        label: fieldFailureReportCount === null || fieldFailureReportCount === void 0 ? void 0 : fieldFailureReportCount.resubmitted,
                                        size: "small",
                                        variant: "filled",
                                        color: "secondary",
                                        sx: {
                                            color: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? 'black' : '',
                                            borderRadius: 6,
                                            px: 1,
                                            fontWeight: "bold",
                                            fontSize: 12
                                        }
                                    })),
                                    variant: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? "outlined" : "text"
                                };
                            }
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: "table",
            columnSize: 12,
            spacing: 0,
            elements: [{
                    type: FormItemTypes.Custom,
                    name: "catalog",
                    columnSize: 12,
                    element: FieldFailureReportCatalog
                }]
        }, !lgMode ? {
            type: FormItemTypes.ContainerItem,
            name: 'Footer',
            columnSize: 12,
            justifyContent: 'end',
            sx: {
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                padding: 2,
                backgroundColor: 'background.paper',
                borderTop: '1px solid',
                borderColor: 'divider',
                zIndex: 1
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: null,
                    columnSize: 12,
                    item: false,
                    spacing: 1,
                    alignItems: "center",
                    elements: [{
                            type: FormItemTypes.Button,
                            variant: 'contained',
                            name: "new",
                            startIcon: /*#__PURE__*/ React.createElement(PlusIcon, null),
                            columnSize: 12,
                            fullWidth: true,
                            children: 'New',
                            onClick: function () { return navigate('/fieldFailureReports/create'); }
                        }]
                }]
        } : null];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        getFormAPI: fieldFailureReportsCountAPI,
        mode: "edit",
        getKey: FieldFailureReportsKeys.count
        // getRequest={{id:'becf120e-c1b6-4699-839d-f67a1bf2936f'}}
        ,
        gridProps: {
            spacing: 0
        },
        onChange: function (e, _ref) {
            var state = _ref.state, field = _ref.field, value = _ref.value;
            handlePagingUpdate(state);
        }
    }));
};
export default FieldFailureReports;
